import {
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
  Button,
  Select,
  MenuItem,
  FormControl,
  Grid2,
  FormLabel,
  TextField,
} from "@mui/material";
import { CloseOutlined } from "@mui/icons-material";
import { useGlobalModalContext } from "../../context/GlobalModalContext";
import MeetingMinuteDialog from "./MeetingMinuteDialog";
import { fileUploadaxiosInstance } from "../../utils/axios";
import { useState } from "react";
import { useLoading } from "../../context/LoadingContext";
import CustomTooltip from "../CustomTooltip";
import { useUploadContext } from "../../context/UploadContext";
import MessageDialog from "./MessageDialog";

const UploadFileDialog = () => {
  const { showModal, hideAllModal, hideModal } = useGlobalModalContext();
  const [selectedLanguage, setSelectedLanguage] = useState("English");
  const [file, setFile] = useState("");
  const [fileError, setFileError] = useState(false);
  const { showLoading, hideLoading } = useLoading();
  const { uploadData, setUploadData } = useUploadContext();
  //console.log("Upload Context:", { uploadData, setUploadData });
  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setFileError(false);
      if (!file) {
        setFileError(true);
        return;
      }
      showLoading();
      const response = await fileUploadaxiosInstance.post(
        "/process_query/upload_file",
        {
          file: file,
        }
      );

      if (response.data) {
        hideModal();
        setUploadData(file.name);
        showModal(
          <MessageDialog
            message="File uploaded Successfully"
            primaryButtonText="OK"
            onPrimaryClick={() => {
              hideModal();
            }}
          />
        );
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      hideLoading();
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      setFile(file);
      setFileError(false);
    }
  };

  return (
    <Dialog open onClose={hideModal} maxWidth={"sm"} fullWidth={true}>
      <DialogTitle>
        <h4 className="font-bold text-center">Upload Document</h4>
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={hideModal}
        sx={(theme) => ({
          position: "absolute",
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseOutlined />
      </IconButton>
      <DialogContent>
        <form onSubmit={(e) => e.preventDefault()}>
          <Grid2 container direction={"row"} rowGap={2}>
            <FormControl size="small" required error={fileError}>
              <input
                type="file"
                accept=".pdf"
                onChange={handleFileChange}
                style={{ display: "none" }}
                id="file-input"
              />
              <FormLabel htmlFor="file-input">
                <span className="text-xs">
                  Upload File (PDF)
                </span>
              </FormLabel>
              <Grid2>
                <label htmlFor="file-input">
                  <Button variant="outlined" component="span">
                    Upload File
                  </Button>
                  {file && (
                    <span className="ml-2 text-sm">
                      Selected File: {file.name}
                    </span>
                  )}
                </label>
              </Grid2>
            </FormControl>
          </Grid2>
          <Grid2 my={2}>
            <Button
              type="submit"
              variant="contained"
              size="small"
              sx={{ textTransform: "none" }}
              onClick={handleSubmit}
            >
              Upload
            </Button>
          </Grid2>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default UploadFileDialog;
